import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";

import {
  loadAvailableHours,
  resetAvailableHours,
} from "../../../_redux/actions/appointmentActions";
import { ConfirmationDialog, RingLoader, TimeLoader } from "@/_components";
import { langConversionHelper } from "@/_helpers";

// import { makeStyles } from "@mui/styles";
import { styled,useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { brandColors } from "../../../_components/brandedComponent/BrandedColors";
import { LifeSafer } from "../../../_helpers/BrandConstants";
import { Australia } from "../../../_helpers/CountryConstants";
import useMediaQuery from "@mui/material/useMediaQuery";

const daysOfTheWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear(),
    time = "12:00 AM";

  if (new Date().toLocaleDateString() === d.toLocaleDateString())
    time = new Date().toLocaleTimeString();
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  let finalDate = [year, month, day].join("-") + " " + time;

  return finalDate;
}

function AppointmentTimes({
  appointmentLocation,
  selectedDate,
  setSelectedDate,
  availableHours,
  loadAvailableHours,
  resetAvailableHours,
  previousStep,
  makeAppointment,
  enrolleeUserData,
  prefillDeviceType,
  dynamicWidth,
  isShowTimeWeb,
  setIsSubmitAppointment,
}) {
  const cookies = new Cookies();
  // const enrolleeUser = cookies.get("lifesaferEnrollment");
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const { t, i18n } = useTranslation();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [notifyMessage, setNotifyMessage] = useState();
  const [selectedHour, setSelectedHour] = useState();
  const [selectedBay, setSelectedBay] = useState(0);
  const [localSubmit, setLocalSubmit] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  // let dynamicWidth = "100%";

  // const useStyles = makeStyles(() => ({
  //   mainCardContainer: {
  //     width: 308,
  //     boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
  //   },
  //   cardHeaderContainer: {
  //     height: 50,
  //     boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
  //   },
  //   customTypo: {
  //     textAlign: "left",
  //     zIndex: 10,
  //     fontWeight: "bold",
  //     fontSize: 18,
  //   },
  //   customTypo2: {
  //     fontSize: 48,
  //     fontWeight: 600,
  //     textShadow: "1px 3px 2px rgba(28,53,94,.4)",
  //     color: "#fff",
  //   },
  //   backButton: {
  //     backgroundColor: brandColors[brand].secondary,
  //     color: "white",
  //     "&:hover": {
  //       backgroundColor: brandColors[brand].secondary,
  //     },
  //     margin: 5,
  //   },
  //   gridrow: {
  //     borderTop: 1,
  //     padding: 5,
  //   },
  // }));

  const StyledBackButton = styled(Button, {
    shouldForwardProp: (prop) => prop !== "brand",
  })(({ brand }) => ({
    backgroundColor: brandColors[brand].secondary,
    color: "white",
    margin: 5,
    "&:hover": {
      backgroundColor: brandColors[brand].secondary,
    },
  }));

  const StyledMainCard = styled(Grid)(() => ({
    width: "100%",
    boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
  }));

  const StyledCardHeader = styled(Grid)(() => ({
    height: 50,
    boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
  }));

  const CustomTypo = styled(Typography)(() => ({
    textAlign: "left",
    zIndex: 10,
    fontWeight: "bold",
    fontSize: 18,
  }));

  const CustomTypo2 = styled(Typography)(() => ({
    fontSize: 48,
    fontWeight: 600,
    textShadow: "1px 3px 2px rgba(28,53,94,.4)",
    color: "#fff",
  }));

  const GridRow = styled(Grid)(() => ({
    // borderTop: "1px solid #ccc",
    padding: 5,
  }));

  // const classes = useStyles();
  useEffect(() => {
    let formattedDate = formatDate(selectedDate);
    loadAvailableHours(
      enrolleeUserData.clientId,
      appointmentLocation.locationID,
      prefillDeviceType,
      "Installation",
      formattedDate
    ).catch((error) => {
      console.log("Loading available hours failed! " + error);
    });
  }, [selectedDate]);

  const handleTimeClick = (hour, bay) => {
    setSelectedHour(hour);
    setSelectedBay(bay);
    handleNotifyMessage(hour);
  };
  const handleGoBack = () => {
    resetAvailableHours();
    setSelectedDate(null);
    previousStep("Calendar");
  };
  function handleNotifyMessage(hour) {
    let siteCountry = cookies.get("siteCountry");
    let locale = siteCountry === Australia ? "en-AU" : "en-US";
    let message =
      t("outro.aptSchedPart1") +
      selectedDate.toLocaleDateString(locale) +
      t("outro.aptSchedPart2") +
      hour +
      t("outro.aptSchedPart3") +
      appointmentLocation.displayName;

    setNotifyMessage(message);
  }
  const handleCreateAppointment = () => {
    setLocalSubmit(true);
    setIsSubmitAppointment(true);
    makeAppointment(selectedHour, selectedBay);
  };
  const handleCancelConfirm = () => {
    setSelectedHour(undefined);
  };

  return (
    <div
      style={{
        maxWidth: `${dynamicWidth}px`,
        marginTop: isShowTimeWeb ? "" : "66px",
        width: "100%",
      }}
    >
      {isShowTimeWeb && (
        <Grid
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          style={{ marginBottom: 20 }}
        >
          <Grid>
            <CustomTypo>{t("outro.selectedLocation")}:</CustomTypo>
          </Grid>
          <Grid>
            <Typography style={{ color: brandColors[brand].secondary }}>
              {appointmentLocation.displayName}
            </Typography>
          </Grid>
        </Grid>
      )}
      {localSubmit === true ? (
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          style={{ height: 345, width: 320 }}
        >
          <RingLoader />
        </Grid>
      ) : (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid sx={{ width: "100%" }}>
            <StyledCardHeader
              container
              direction="row"
              // className={classes.cardHeaderContainer}
              alignItems="center"
              width="100%"
              style={{ backgroundColor: brandColors[brand].primary }}
            >
              {isShowTimeWeb && (
                <Grid
                  size={{ xs: 3 }}
                  style={{ textAlign: "center", marginTop: -12,paddingLeft:isMobile?"4px":"0px" }}
                >
                  <Typography
                    style={{ fontWeight: 600, fontSize: 28, color: "#fff" }}
                  >
                    {t("outro.date")}:
                  </Typography>
                </Grid>
              )}
              <Grid size={{ xs: 9 }}  sx={isMobile ? {} : { width: "100%" }} >
                <Grid container direction="row" style={{ marginTop: -12 }}>
                  <Grid
                    size={{ xs: 5 }}
                    style={{ textAlign: "right", paddingRight: 8 }}
                  >
                    <CustomTypo2>{selectedDate.getDate()}</CustomTypo2>
                  </Grid>
                  <Grid
                    size={{ xs: 7 }}
                    style={{ textAlign: "left", paddingTop: 13 }}
                  >
                    <Typography
                      style={{ fontWeight: 600, fontSize: 18, color: "#fff" }}
                    >
                      {i18n.language !== "en"
                        ? langConversionHelper.dayConversion(
                            daysOfTheWeek[selectedDate.getDay()],
                            i18n.language
                          )
                        : daysOfTheWeek[selectedDate.getDay()]}
                    </Typography>
                    <Typography style={{ fontSize: 12, color: "#fff" }}>
                      {i18n.language !== "en"
                        ? langConversionHelper.monthConversion(
                            months[selectedDate.getMonth()],
                            i18n.language
                          )
                        : months[selectedDate.getMonth()]}
                      {", " + selectedDate.getFullYear()}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </StyledCardHeader>
            <StyledMainCard
              container
              direction="row"
              // className={classes.mainCardContainer}
              justifyContent="center"
              width="100%"
              style={{ height: isShowTimeWeb ? 308 : 295 }}
            >
              {isShowTimeWeb && (
                <Grid
                  size={{ xs: 5 }}
                  style={{
                    borderRight: `1px solid ${brandColors[brand].primary}`,
                    height: 308,
                  }}
                >
                  <Typography
                    style={{
                      fontWeight: 600,
                      fontSize: 28,
                      paddingTop: 20,
                      paddingLeft: 5,
                    }}
                  >
                    {t("outro.time")}:
                  </Typography>
                </Grid>
              )}
              <Grid
                size={{ xs: 7 }}
                style={{ paddingTop: 4, width: isShowTimeWeb ? "" : "100%" }}
              >
                <Grid
                  container
                  direction="column"
                  style={{
                    height: 290,
                    overflowX: "hidden",
                    overflowY: "scroll",
                  }}
                >
                  {availableHours[0].CurrentState === "Undefined" ? (
                    <Grid
                      container
                      direction="column"
                      justifyContent="center"
                      alignItems="center"
                      style={{ marginTop: 45 }}
                    >
                      <TimeLoader />
                    </Grid>
                  ) : availableHours[0].CurrentState === "None" ? (
                    <Grid
                      container
                      direction="column"
                      justifyContent="center"
                      alignItems="center"
                      style={{ marginTop: 5 }}
                    >
                      <Typography style={{ textAlign: "center" }}>
                        {t("outro.noTimesAvailable")}
                      </Typography>
                    </Grid>
                  ) : (
                    <>
                      <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        style={{ marginTop: 5 }}
                      >
                        <Grid>
                          {availableHours.map((availableHour, i) => {
                            return (
                              <GridRow key={i}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => {
                                    handleTimeClick(
                                      availableHour.hour,
                                      availableHour.bayID
                                    );
                                    setConfirmOpen(true);
                                  }}
                                  style={{ width: 100 }}
                                >
                                  {availableHour.hour}
                                </Button>
                              </GridRow>
                            );
                          })}
                          <Grid style={{ padding: 5 }}>
                            <ConfirmationDialog
                              title={t("outro.confirmation")}
                              open={confirmOpen}
                              setOpen={setConfirmOpen}
                              onConfirm={() => handleCreateAppointment()}
                              onCancel={() => handleCancelConfirm()}
                              confirmBtnLabel={t("outro.yesButton")}
                            >
                              {notifyMessage}
                            </ConfirmationDialog>
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
            </StyledMainCard>
          </Grid>
        </Grid>
      )}
      {isShowTimeWeb && (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          style={{ padding: "25px 0px" }}
        >
          <Grid>
            <StyledBackButton
              brand={brand}
              aria-label="return"
              variant="contained"
              // className={classes.backButton}
              size="medium"
              startIcon={<ArrowBackRoundedIcon />}
              onClick={() => handleGoBack()}
              disabled={
                availableHours[0].CurrentState === "Undefined" ||
                localSubmit === true
              }
            >
              {t("outro.backToCalendar")}
            </StyledBackButton>
          </Grid>
        </Grid>
      )}
    </div>
  );
}

AppointmentTimes.propTypes = {
  availableHours: PropTypes.array,
  loadAvailableHours: PropTypes.func.isRequired,
  resetAvailableHours: PropTypes.func.isRequired,
  appointmentLocation: PropTypes.object,
  selectedDate: PropTypes.instanceOf(Date),
  previousStep: PropTypes.func.isRequired,
  setSelectedDate: PropTypes.func.isRequired,
  makeAppointment: PropTypes.func.isRequired,
  enrolleeUserData: PropTypes.object,
  prefillDeviceType: PropTypes.string,
  dynamicWidth: PropTypes.number,
  isShowTimeWeb: PropTypes.bool,
  setIsSubmitAppointment: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    availableHours: state.availableHours,
  };
}

const mapDispatchToProps = {
  loadAvailableHours,
  resetAvailableHours,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentTimes);
